/**
 * Zendesk Chat Helper Utility
 * Functions to open and interact with Zendesk chat widget
 */

/**
 * Open Zendesk chat widget
 * Waits for zE (Zendesk) to be available before opening
 */
export function openZendeskChat() {
  // Check if Zendesk widget is loaded
  if (window.zE) {
    try {
      window.zE('webWidget', 'open');
    } catch (error) {
      console.error('Error opening Zendesk chat:', error);
    }
  } else {
    // If not loaded yet, wait and retry
    console.log('Zendesk chat not loaded yet, waiting...');
    let retryCount = 0;
    const maxRetries = 10;
    
    const checkInterval = setInterval(() => {
      retryCount++;
      
      if (window.zE) {
        clearInterval(checkInterval);
        try {
          window.zE('webWidget', 'open');
        } catch (error) {
          console.error('Error opening Zendesk chat:', error);
        }
      } else if (retryCount >= maxRetries) {
        clearInterval(checkInterval);
        console.error('Zendesk chat failed to load after multiple retries');
        alert('Chat is currently unavailable. Please contact us via phone or email.');
      }
    }, 500); // Check every 500ms
  }
}

/**
 * Close Zendesk chat widget
 */
export function closeZendeskChat() {
  if (window.zE) {
    try {
      window.zE('webWidget', 'close');
    } catch (error) {
      console.error('Error closing Zendesk chat:', error);
    }
  }
}

/**
 * Show Zendesk chat widget
 */
export function showZendeskChat() {
  if (window.zE) {
    try {
      window.zE('webWidget', 'show');
    } catch (error) {
      console.error('Error showing Zendesk chat:', error);
    }
  }
}

/**
 * Hide Zendesk chat widget
 */
export function hideZendeskChat() {
  if (window.zE) {
    try {
      window.zE('webWidget', 'hide');
    } catch (error) {
      console.error('Error hiding Zendesk chat:', error);
    }
  }
}
